import React, {useEffect, useState} from 'react';
import { Tooltip, Typography, Fab, Dialog, Card, DialogContent, Grid, Paper, IconButton } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import { SignOutButton, handleSignOut } from '../../Auth';

import { getJsonFromS3 } from '../../DataRetrieval';
import PlantAssetInventoryTable from './PlantAssetInventoryTable';
import KPICards from './KPICards/KPICards'
import { filterAndUpdateFeatures } from './KPICards/KPIUtils';

import { DataProvider, useDataSetters, useDataState } from '../../../DataContext';

const LandingDashboard = () => {

    // App state management; see DataContext.js
    const {
        user,
        selectedBucket,
        selectedVineyard,
        landingDashboardOpen,
        fileInsightsDataCache,
        plantAssetClasses,
        geoJsonVineData,
        dataLoaded,
        geoJsonBlockData,
        kpiSettingsTable,
        geoJsonVineMaturityData,
        geoJsonVineMaturityNoData,
    } = useDataState();

    const {
        setUser,
        setCurrentUserView,
        setLandingDashboardOpen,
        setFileInsightsDataCache,
        setPlantAssetClasses,
        setKpiSettingsTable,
    } = useDataSetters();

   // Handle sign out click
    const handleSignOutClick = () => {
        handleSignOut(setUser);
    };

    useEffect (() => {
        console.log('kpiSettingsTable Landing Dashboard', kpiSettingsTable)
    }, [kpiSettingsTable])

    function createSummary(pointFeatures, pointFeaturesNoData, vineyardId, classMapping) {
        // Initialize summary object
        let summary = {
            vineyard_id: vineyardId,
            blocks: {}
        };
    
        pointFeatures.features.forEach(feature => {
            const blockName = feature.properties.block_name;
            const classMaturity = feature.properties.class_maturity;
            const classCanopy = feature.properties.class_canopy_rating;
            const classFruit = feature.properties.class_fruit_rating;
    
            // Initialize block in summary if it doesn't exist
            if (!summary.blocks[blockName]) {
                summary.blocks[blockName] = {};
                console.log('Object.values(classMapping)', Object.values(classMapping));
                Object.values(classMapping).forEach(field => {
                    summary.blocks[blockName][field] = 0;
                });
            }
    
            // Increment the count for the class
            if (classMapping[classMaturity]) {
                summary.blocks[blockName][classMapping[classMaturity]]++;
            }
            if (classMapping[classCanopy]) {
                summary.blocks[blockName][classMapping[classCanopy]]++;
            }
            if (classMapping[classFruit]) {
                summary.blocks[blockName][classMapping[classFruit]]++;
            }
        });

        pointFeaturesNoData.features.forEach(feature => {
            const blockName = feature.properties.block_name;

            if (!summary.blocks[blockName]) {
                summary.blocks[blockName] = {};
                console.log('Object.values(classMapping)', Object.values(classMapping));
                Object.values(classMapping).forEach(field => {
                    summary.blocks[blockName][field] = 0;
                });
            };

            if (!summary.blocks[blockName]) {
                summary.blocks[blockName] = {};
                summary.blocks[blockName]['number_nodata_vines'] = 0;
            }

            summary.blocks[blockName]['number_nodata_vines']++;
        });
    
        // Convert blocks object to array
        summary.blocks = Object.entries(summary.blocks).map(([block_id, counts]) => ({
            block_id,
            ...counts
        }));

        console.log('summary.blocks', summary.blocks)
    
        return [summary];
    }
    
    const classMapping = {
        'MatureVine': 'number_mature_vines',
        'WeakVine': 'number_weak_vines',
        'WeakCanopy': 'number_weak_canopies',
        'WeakFruit': 'number_weak_fruits',
        'MissingVine': 'number_missing_vines',
        'RootStock': 'number_rootstocks',
        'Replant': 'number_replanted_vines',
        'YoungVine': 'number_young_vines',
        'NoData': 'number_nodata_vines'
    };
       
    
    // Download plantAssetClasses table from S3
    useEffect(() => {

        let summary
        const _plantAssetClasses = () => {
            if (geoJsonVineMaturityData && geoJsonVineMaturityNoData) {
            summary = createSummary(geoJsonVineMaturityData, geoJsonVineMaturityNoData, selectedVineyard, classMapping);
            console.log('summary', summary)
            setPlantAssetClasses(summary);
        }};


        async function fetchData() {
            try {
                // const _plantAssetClasses = await getJsonFromS3(
                //     `${selectedBucket}/${selectedVineyard}/kit_insights/Summary_2023/plant_asset_classes_test.json`, 
                //     user, 
                //     fileInsightsDataCache, 
                //     setFileInsightsDataCache
                // );

                // setPlantAssetClasses(_plantAssetClasses);
                _plantAssetClasses();
                // const kpiData = await getJsonFromS3(`${selectedBucket}/${selectedVineyard}/kit_insights/Summary_2023/kpiSettingsTable.json`);
                // setKpiSettingsTable(kpiData);
                console.log("Fetched plantAssetClasses data from S3: ", _plantAssetClasses)
            } catch (error) {
                console.error("Error fetching plantAssetClasses data from S3:", error);
                // Handle the error. You can set some state here to notify the user, or whatever you deem necessary.
            }
        }

        if (geoJsonVineData) {
            fetchData();
        }

    }, [geoJsonVineData, selectedBucket, selectedVineyard, user, fileInsightsDataCache, setFileInsightsDataCache, geoJsonVineMaturityData]);


    const closeDashboard = () => {
        setLandingDashboardOpen(null);
        setCurrentUserView('Map');
    };

    return (
        <div>
            <Dialog 
                open={Boolean(landingDashboardOpen)} 
                onClose={closeDashboard} 
                fullScreen
                PaperProps={{ style: { backgroundColor: "rgb(240, 240, 240)", boxShadow: "none" }}}
            >
                <div style={{ flex: 1, maxWidth: 'calc(100% - 105px)' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <KPICards/>
                        </Grid>
                        <Grid item xs={12} style={{marginRight:'27px'}}>  {/* marginRight shouldn't be hardcoded */}
                            <PlantAssetInventoryTable data={plantAssetClasses} />
                        </Grid>
                    </Grid>;
                </div>
                
                {/* <div style={{ flex: 1, maxWidth: 'calc(100% - 95px)' }}>
                    <KPICards/>
                    <PlantAssetInventoryTable data={plantAssetClasses} />
                </div> */}

                <div style={{ flex: 0.05 }}> 
                    <DialogContent>
                        <Tooltip title={<Typography sx={{ fontSize: 14 }}>Map View</Typography>}>
                            <Fab
                                color="primary"
                                aria-label="landing-dashboard-viewer"
                                onClick={closeDashboard}
                                style={{ position: 'fixed', top: '80px', right: '10px' }}
                                disabled={geoJsonVineData !== null ? false : true}
                            >
                                <MapIcon />
                            </Fab>
                        </Tooltip>
                    </DialogContent>
                </div>

                <SignOutButton 
                    user={user} 
                    handleSignOut={handleSignOutClick} 
                />
            </Dialog>
        </div>
    );
};

export default LandingDashboard;

